import type { RouteRecordRaw } from 'vue-router'
import TariffDashboard from '@/views/tariffs/tariff-dashboard.vue'
import TariffAssetsDashboard from '@/views/tariffs/tariff-asset-dashboard.vue'

export default [
  {
    path: '/admin/tariffs',
    redirect: { name: 'tariffs.list' }
  },
  {
    path: '/tariffs',
    component: TariffDashboard,
    name: 'tariffs.list',
    meta: {
      pageTitle: 'Tariff Management',
    }
  },
  {
    path: '/tariffs/assets',
    component: TariffAssetsDashboard,
    name: 'tariffs.assets',
    meta: {
      pageTitle: 'Tariff Assets',
    }
  }
] satisfies RouteRecordRaw[] as RouteRecordRaw[]
